.thumbnail-component-container {
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
  }

  .text-fallback {
    font-size: 16px;
    color: var(--gray);
    display: flex;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    height: 172px;
  }

  .provider {
    position: absolute;
    bottom: -2px;
    right: -2px;
    margin: 0;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .trend {
    height: 26px;
    width: 26px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    bottom: -1px;
    border: 1px solid var(--base_color2);
    background-color: var(--trend);

    .icon {
      height: 14px;
      width: 14px;
      fill: var(--base_color2);
    }
  }

  .thumbnail-no-image {
    max-height: 173px;
    background: var(--gray_insights3);
    border-radius: 50%;
    width: 100%;
    height: 100%;
    display: block;
  }
}
